type GetReturnType = string | null;

export const addSession = (key: string, value: string) => {
  window.sessionStorage.setItem(key, value);
};

export const getSession = (key: string): GetReturnType => {
  return window.sessionStorage.getItem(key);
};

export const deleteSession = (key: string): void => {
  window.sessionStorage.removeItem(key);
};

export const addLocal = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

export const getLocal = (key: string): GetReturnType => {
  return window.localStorage.getItem(key);
};

export const deleteLocal = (key: string): void => {
  window.localStorage.removeItem(key);
};

export const serialize = (item: any): string => {
  return JSON.stringify(item);
};

export const deserialize = (item: string): any => {
  return JSON.parse(item);
};

export const deepClone = (sItem: any) => {
  return JSON.parse(JSON.stringify(sItem));
};

// cookies methods

export const addSessionCookie = (key: string, value: string | boolean): void => {
  document.cookie = `${key}=${value}; path=/;`;
};

export const getSessionCookie = (key: string): GetReturnType => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) {
    return parts?.pop()?.split(';').shift() || null;
  }
  return null;
};

export const deleteSessionCookie = (key: string): void => {
  document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
